import RefreshIcon from '@/assets/refresh.svg?react'
import type { MouseEvent } from 'react'
import styles from './StoryMedia.module.css'

export interface StoryMediaErrorProps {
	message: string
	onRetry?: () => void
}

export default function StoryMediaError({ message, onRetry }: StoryMediaErrorProps) {
	const handleRetryClick = (event: MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation()
		onRetry?.()
	}

	return (
		<div className={styles.mediaError} role="alert">
			<span>{message}</span>
			{onRetry && (
				<button type="button" className={styles.retryButton} onClick={handleRetryClick}>
					<RefreshIcon aria-hidden="true" />
					重试
				</button>
			)}
		</div>
	)
}
